import { Box, Button, Chip, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";

export const leadTypeColumns = (editLeadType, toggleStatus): GridColDef[] => {
  return [
    {
      field: "leadTypeName",
      headerName: "Lead Type",
      flex: 2,
      minWidth: 200,
      sortable: false,
    },
    {
      field: "notes",
      headerName: "Status",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <Chip
          label={params.row.isActive ? "Active" : "Inactive"}
          sx={{
            backgroundColor: params.row.isActive ? "#4caf50" : "#f44336",
            color: "#fff",
            fontWeight: 500,
          }}
          size="small"
        />
      ),
    },
    {
      field: "edit",
      headerName: "Edit",
      flex: 0.5,
      minWidth: 80,
      sortable: false,
      renderCell: (params) => (
        <IconButton color="primary" onClick={() => editLeadType(params.row)}>
          <EditTwoToneIcon />
        </IconButton>
      ),
    },
    {
      field: "toggleStatus",
      headerName: "Activate/Deactivate",
      flex: 1,
      minWidth: 180,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          color={params.row.isActive ? "error" : "success"}
          size="small"
          onClick={() => toggleStatus(params.row)}
        >
          {params.row.isActive ? "Deactivate" : "Activate"}
        </Button>
      ),
    },
  ];
};
